"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var FSTypes = _interopRequireWildcard(require("../types"));
var Types = FSTypes;
var _types2 = require("../../Hint/types");
var _usePrevious = _interopRequireDefault(require("../../../hooks/usePrevious"));
var _react = _interopRequireWildcard(require("react"));
var Reducers = _interopRequireWildcard(require("../reducers"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var getFormDataState = function getFormDataState(initialValue) {
  if (initialValue === undefined || _typeof(initialValue) === "object" && Object.values(initialValue).filter(Boolean).filter(function (field) {
    return field.value && field.value !== "";
  }).length === 0) {
    return FSTypes.FormContext.Types.Create;
  }
  return FSTypes.FormContext.Types.Update;
};
var useBuildFormContext = function useBuildFormContext(props) {
  var _a, _b;
  var defaultValue = props.defaultValue,
    disabled = props.disabled,
    i18n = props.i18n,
    initialValue = props.initialValue,
    onCancel = props.onCancel,
    onChange = props.onChange,
    onDelete = props.onDelete;
  var _c = _react.default.useReducer(Reducers.FormContextReducer, {
      formData: initialValue || defaultValue || {},
      i18n: i18n,
      isCanceling: false,
      isDeleting: false,
      isSubmitting: false,
      onCancel: onCancel,
      onDelete: onDelete,
      type: getFormDataState(initialValue),
      validations: {
        field: [],
        form: []
      }
    }),
    state = _c[0],
    dispatch = _c[1];
  var previousState = (0, _usePrevious.default)(state.validations);
  var generateFieldValidationMessages = (0, _react.useCallback)(function (fieldName, formData, validateOnChangeOnly) {
    var fieldValidationMessages = state.validations.field.reduce(function (validationResult, validation) {
      var _a;
      return __spreadArray(__spreadArray([], validationResult, true), validation.fieldName === fieldName && (!validateOnChangeOnly || validation.validateOnChange) ? validation.validationFunction((_a = formData[fieldName]) === null || _a === void 0 ? void 0 : _a.value, fieldName).map(function (validationMessage) {
        return __assign(__assign({}, validationMessage), {
          validationId: validation.validationId
        });
      }) : [], true);
    }, []);
    var formValidationMessages = state.validations.form.reduce(function (validationResult, validation) {
      return __spreadArray(__spreadArray([], validationResult, true), validation.involvedFieldNames.includes(fieldName) && (!validateOnChangeOnly || validation.validateOnChange) ? validation.validationFunction(formData).map(function (validationMessage) {
        return __assign(__assign({}, validationMessage), {
          validationId: validation.validationId
        });
      }) : [], true);
    }, []);
    return __spreadArray(__spreadArray([], fieldValidationMessages, true), formValidationMessages, true);
  }, [state.validations.field, state.validations.form]);
  var addAdditionalInputProp = (0, _react.useCallback)(function (fieldName, key, value) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.AddAdditionalInputProp,
      payload: {
        fieldName: fieldName,
        key: key,
        value: value
      }
    });
  }, []);
  var addFieldValidation = (0, _react.useCallback)(function (validationId, fieldName, validationFunction, validateOnChange) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.AddFieldValidation,
      payload: {
        validationId: validationId,
        fieldName: fieldName,
        validationFunction: validationFunction,
        validateOnChange: validateOnChange
      }
    });
  }, []);
  var addFormValidation = (0, _react.useCallback)(function (validationId, involvedFieldNames, validationFunction, validateOnChange) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.AddFormValidation,
      payload: {
        validationId: validationId,
        involvedFieldNames: involvedFieldNames,
        validationFunction: validationFunction,
        validateOnChange: validateOnChange
      }
    });
  }, []);
  var addValidationMessages = (0, _react.useCallback)(function (fieldName, validationMessages) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.AddValidationMessages,
      payload: {
        fieldName: fieldName,
        validationMessages: validationMessages
      }
    });
  }, []);
  var clearValidationMessages = (0, _react.useCallback)(function (fieldName, types) {
    if (types === void 0) {
      types = [Types.ValidationTypes.Error, Types.ValidationTypes.Warning, Types.ValidationTypes.Success, Types.ValidationTypes.Loading];
    }
    dispatch({
      type: Types.FormContext.ReducerActionTypes.ClearValidationMessages,
      payload: {
        fieldName: fieldName,
        types: types
      }
    });
  }, []);
  var clearAllValidationMessages = (0, _react.useCallback)(function (types) {
    if (types === void 0) {
      types = [Types.ValidationTypes.Error, Types.ValidationTypes.Warning, Types.ValidationTypes.Success, Types.ValidationTypes.Loading];
    }
    dispatch({
      type: Types.FormContext.ReducerActionTypes.ClearAllValidationMessages,
      payload: {
        types: types
      }
    });
  }, []);
  var initializeField = (0, _react.useCallback)(function (fieldName, defaultValue) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.InitializeFormDataField,
      payload: {
        fieldName: fieldName,
        defaultValue: defaultValue
      }
    });
  }, []);
  var getButtonLabel = (0, _react.useCallback)(function (buttonType) {
    var _a, _b;
    return (_b = (_a = state === null || state === void 0 ? void 0 : state.i18n) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b[buttonType];
  }, [(_a = state === null || state === void 0 ? void 0 : state.i18n) === null || _a === void 0 ? void 0 : _a.buttons]);
  var getFieldLabel = (0, _react.useCallback)(function (fieldName) {
    var _a, _b;
    return (_b = (_a = state === null || state === void 0 ? void 0 : state.i18n) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b[fieldName];
  }, [(_b = state === null || state === void 0 ? void 0 : state.i18n) === null || _b === void 0 ? void 0 : _b.fields]);
  var getFieldValidationMessages = (0, _react.useCallback)(function (fieldName) {
    var _a, _b;
    return ((_b = (_a = state === null || state === void 0 ? void 0 : state.formData) === null || _a === void 0 ? void 0 : _a[fieldName]) === null || _b === void 0 ? void 0 : _b.validationMessages) || [];
  }, [state === null || state === void 0 ? void 0 : state.formData]);
  var getHighestValidationMessageType = (0, _react.useCallback)(function (fieldName) {
    var _a, _b;
    var validationStateOrder = Object.values(_types2.HintTypes);
    return (((_b = (_a = state === null || state === void 0 ? void 0 : state.formData) === null || _a === void 0 ? void 0 : _a[fieldName]) === null || _b === void 0 ? void 0 : _b.validationMessages) || []).reduce(function (highest, current) {
      if (!highest) {
        return current === null || current === void 0 ? void 0 : current.type;
      }
      return highest && validationStateOrder.indexOf(highest) <= validationStateOrder.indexOf(current === null || current === void 0 ? void 0 : current.type) ? highest : current === null || current === void 0 ? void 0 : current.type;
    }, undefined);
  }, [state === null || state === void 0 ? void 0 : state.formData]);
  var getFieldValue = (0, _react.useCallback)(function (fieldName) {
    var _a, _b;
    return (_b = (_a = state === null || state === void 0 ? void 0 : state.formData) === null || _a === void 0 ? void 0 : _a[fieldName]) === null || _b === void 0 ? void 0 : _b.value;
  }, [state === null || state === void 0 ? void 0 : state.formData]);
  var getFormData = (0, _react.useCallback)(function () {
    return state === null || state === void 0 ? void 0 : state.formData;
  }, [state === null || state === void 0 ? void 0 : state.formData]);
  var removeFieldValidation = (0, _react.useCallback)(function (fieldName, validationId) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.RemoveFieldValidation,
      payload: {
        fieldName: fieldName,
        validationId: validationId
      }
    });
  }, []);
  var removeFormValidation = (0, _react.useCallback)(function (validationId) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.RemoveFormValidation,
      payload: {
        validationId: validationId
      }
    });
  }, []);
  var setFieldValue = (0, _react.useCallback)(function (fieldName, fieldValue, requiresValidation, isManualChange) {
    var _a;
    if (requiresValidation === void 0) {
      requiresValidation = false;
    }
    if (isManualChange === void 0) {
      isManualChange = false;
    }
    dispatch({
      type: Types.FormContext.ReducerActionTypes.SetFormDataFieldValue,
      payload: {
        fieldName: fieldName,
        value: fieldValue,
        requiresValidation: requiresValidation,
        isManualChange: isManualChange
      }
    });
    if (onChange) {
      var formData = __assign(__assign({}, state.formData), (_a = {}, _a[fieldName] = __assign(__assign({}, state.formData[fieldName]), {
        value: fieldValue,
        requiresValidation: requiresValidation
      }), _a));
      var validationMessages = generateFieldValidationMessages(fieldName, formData);
      onChange(fieldName, fieldValue, validationMessages.reduce(function (valid, message) {
        return valid && message.type !== Types.ValidationTypes.Error;
      }, true), isManualChange, formData, function (fieldName, fieldValue, requiresValidation) {
        if (requiresValidation === void 0) {
          requiresValidation = true;
        }
        setFieldValue(fieldName, fieldValue, requiresValidation, true);
      });
    }
  }, [generateFieldValidationMessages, onChange, state.formData]);
  var setIsCanceling = (0, _react.useCallback)(function (isCanceling) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.SetIsCanceling,
      payload: {
        isCanceling: isCanceling
      }
    });
  }, []);
  var setIsDeleting = (0, _react.useCallback)(function (isDeleting) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.SetIsDeleting,
      payload: {
        isDeleting: isDeleting
      }
    });
  }, []);
  var setIsSubmitting = (0, _react.useCallback)(function (isSubmitting) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.SetIsSubmitting,
      payload: {
        isSubmitting: isSubmitting
      }
    });
  }, []);
  var terminateField = (0, _react.useCallback)(function (fieldName) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.TerminateFormDataField,
      payload: {
        fieldName: fieldName
      }
    });
  }, []);
  var validateField = (0, _react.useCallback)(function (fieldName, formData, validateOnChangeOnly) {
    dispatch({
      type: Types.FormContext.ReducerActionTypes.ResetFieldRequiresValidation,
      payload: {
        fieldName: fieldName
      }
    });
    var validationMessages = generateFieldValidationMessages(fieldName, formData, validateOnChangeOnly);
    validationMessages.forEach(function (validationMessage) {
      addValidationMessages(validationMessage.fieldName, [validationMessage]);
    });
    return validationMessages;
  }, [addValidationMessages, generateFieldValidationMessages]);
  var validateForm = (0, _react.useCallback)(function (formData) {
    var fieldValidationMessages = state.validations.field.reduce(function (validationResult, validation) {
      var _a;
      return __spreadArray(__spreadArray([], validationResult, true), validation.validationFunction((_a = formData === null || formData === void 0 ? void 0 : formData[validation === null || validation === void 0 ? void 0 : validation.fieldName]) === null || _a === void 0 ? void 0 : _a.value, validation === null || validation === void 0 ? void 0 : validation.fieldName).map(function (validationMessage) {
        return __assign(__assign({}, validationMessage), {
          validationId: validation.validationId
        });
      }), true);
    }, []);
    var formValidationMessages = state.validations.form.reduce(function (validationResult, validation) {
      return __spreadArray(__spreadArray([], validationResult, true), validation.validationFunction(formData).map(function (validationMessage) {
        return __assign(__assign({}, validationMessage), {
          validationId: validation.validationId
        });
      }), true);
    }, []);
    var validationMessages = __spreadArray(__spreadArray([], fieldValidationMessages, true), formValidationMessages, true);
    validationMessages.forEach(function (validationMessage) {
      addValidationMessages(validationMessage.fieldName, [validationMessage]);
    });
    return validationMessages;
  }, [addValidationMessages, state.validations.field, state.validations.form]);
  (0, _react.useEffect)(function () {
    var existingFieldValidationIds = previousState.field.map(function (message) {
      return message.validationId;
    });
    var existingFormValidationIds = previousState.form.map(function (message) {
      return message.validationId;
    });
    var newFieldValidations = state.validations.field.filter(function (message) {
      return !existingFieldValidationIds.includes(message.validationId);
    });
    var newFormValidations = state.validations.form.filter(function (message) {
      return !existingFormValidationIds.includes(message.validationId);
    });
    if (newFieldValidations.length > 0 || newFormValidations.length > 0) {
      var fieldValidationMessages = newFieldValidations.reduce(function (validationResult, validation) {
        var _a;
        return __spreadArray(__spreadArray([], validationResult, true), validation.validationFunction((_a = state === null || state === void 0 ? void 0 : state.formData[validation.fieldName]) === null || _a === void 0 ? void 0 : _a.value, validation.fieldName).map(function (validationMessage) {
          return __assign(__assign({}, validationMessage), {
            validationId: validation.validationId
          });
        }), true);
      }, []);
      var formValidationMessages = state.validations.form.reduce(function (validationResult, validation) {
        return __spreadArray(__spreadArray([], validationResult, true), validation.validationFunction(state === null || state === void 0 ? void 0 : state.formData).map(function (validationMessage) {
          return __assign(__assign({}, validationMessage), {
            validationId: validation.validationId
          });
        }), true);
      }, []);
      var validationMessages = __spreadArray(__spreadArray([], fieldValidationMessages, true), formValidationMessages, true).filter(function (validationMessage) {
        return (state === null || state === void 0 ? void 0 : state.type) === FSTypes.FormContext.Types.Update || [FSTypes.ValidationTypes.Info, FSTypes.ValidationTypes.Loading].includes(validationMessage.type);
      });
      validationMessages.forEach(function (validationMessage) {
        addValidationMessages(validationMessage.fieldName, [validationMessage]);
      });
    }
  }, [addValidationMessages, previousState, state === null || state === void 0 ? void 0 : state.formData, state === null || state === void 0 ? void 0 : state.type, state.validations]);
  (0, _react.useEffect)(function () {
    // validate fields that were not changed by the form system but by a manual setFieldValue call from the outside
    Object.values(state.formData).forEach(function (field) {
      if (field.requiresValidation) {
        clearValidationMessages(field.name, "all");
        validateField(field.name, state.formData);
      }
    });
  }, [clearValidationMessages, state.formData, validateField]);
  return __assign(__assign({}, state), {
    addAdditionalInputProp: addAdditionalInputProp,
    addFieldValidation: addFieldValidation,
    addFormValidation: addFormValidation,
    addValidationMessages: addValidationMessages,
    clearAllValidationMessages: clearAllValidationMessages,
    clearValidationMessages: clearValidationMessages,
    disabled: Boolean(disabled),
    initializeField: initializeField,
    isActing: state.isCanceling || state.isDeleting || state.isSubmitting,
    getButtonLabel: getButtonLabel,
    getFieldLabel: getFieldLabel,
    getFieldValidationMessages: getFieldValidationMessages,
    getHighestValidationMessageType: getHighestValidationMessageType,
    getFieldValue: getFieldValue,
    getFormData: getFormData,
    removeFieldValidation: removeFieldValidation,
    removeFormValidation: removeFormValidation,
    setFieldValue: setFieldValue,
    setIsCanceling: setIsCanceling,
    setIsDeleting: setIsDeleting,
    setIsSubmitting: setIsSubmitting,
    terminateField: terminateField,
    validateField: validateField,
    validateForm: validateForm
  });
};
var _default = useBuildFormContext;
exports.default = _default;